var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FF7834"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 7C8.56813 7 7 8.56814 7 10.5001C7 12.432 8.56813 14.0001 10.5 14.0001C12.4319 14.0001 14.0001 12.432 14.0001 10.5001C14.0001 8.56814 12.4319 7 10.5 7ZM10.5 9.00005C9.67204 9.00005 9.00004 9.67205 9.00004 10.5001C9.00004 11.328 9.67204 12 10.5 12C11.328 12 12 11.328 12 10.5001C12 9.67205 11.328 9.00005 10.5 9.00005ZM19.5 15.9999C17.5681 15.9999 15.9999 17.568 15.9999 19.4999C15.9999 21.4319 17.5681 23 19.5 23C21.4319 23 23 21.4319 23 19.4999C23 17.568 21.4319 15.9999 19.5 15.9999ZM19.5 18C18.672 18 18 18.672 18 19.4999C18 20.3279 18.672 20.9999 19.5 20.9999C20.328 20.9999 21 20.3279 21 19.4999C21 18.672 20.328 18 19.5 18ZM9.33733 22.0767C8.94994 22.4641 8.32213 22.4643 7.92892 22.071C7.53835 21.6805 7.54371 21.042 7.92323 20.6626L20.6624 7.92336C21.0498 7.53597 21.6776 7.53581 22.0708 7.92906C22.4614 8.31962 22.456 8.95814 22.0765 9.33747L9.33733 22.0767Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.cba0a74f579ff54eeddd8bfa288d634c.svg";
export { ForwardRef as ReactComponent };